import { Box } from '@mui/system';
import { RichTextInput } from 'ra-input-rich-text';
import * as React from 'react';
import {
  Create,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  required,
  ImageInput,
  BooleanInput,
  NumberInput,
  DateInput,
  DateTimeInput,
  ImageField,
} from 'react-admin';

export default function ResourceCreate(props: any) {
  return (
    <Box sx={styles.boxStyle}>
      <Create sx={styles.createStyle} {...props}>
        <SimpleForm style={styles.inputStyle}>
          <TextInput source='name' sx={styles.inputStyle} />
          <ImageInput
            source='image'
            label='Image'
            accept='image/*'
            placeholder={<p>Drop your file here</p>}
          >
            <ImageField source='src' title='title' />
          </ImageInput>
          <NumberInput source='discount' sx={styles.inputStyle} />
          <BooleanInput source='isActive' sx={styles.inputStyle} />
          <BooleanInput source='isPercentage' sx={styles.inputStyle} />
        </SimpleForm>
      </Create>
    </Box>
  );
}

const styles = {
  boxStyle: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  createStyle: {
    width: '50%',
    minWidth: 250,
  },
  inputStyle: {
    width: '100%',
  },
};
